import {ReactElement} from 'react';
import StyledCtaLink from './styles';
import Props from './typings';

const CtaLink = ({
  className,
  href,
  title,
  target,
  disabled,
  maxWidth,
  style = 'primary',
  onClick,
  children,
}: Props): ReactElement => {
  return (
    <StyledCtaLink
      className={className}
      href={disabled ? '' : href}
      target={target}
      role="button"
      aria-label={title ? title : children}
      aria-disabled={disabled}
      onClick={disabled ? undefined : onClick}
      $style={style}
      $maxWidth={maxWidth}
    >
      {children}
    </StyledCtaLink>
  );
};

export default CtaLink;
